import React, { useState } from 'react';
import { forNamespace } from 'app/common/lib/util/i18n';
import styles from './TeamlessCollaborationPromptPopover.less';
import { TeamlessCollaborationCreateTeam } from './TeamlessCollaborationCreateTeam';
import { TeamlessCollaborationPromptPopoverId } from 'app/gamma/src/components/popovers/popover-ids';
import {
  Popover,
  PopoverProps,
  closeMethods,
} from 'app/gamma/src/components/popover';
import {
  Button,
  ButtonSizes,
  ButtonTypes,
} from 'app/common/components/controls/button/button';
import { Noun, Verb, trackUe } from '@trello/analytics';

const Auth = require('app/scripts/db/auth');

const format = forNamespace('teamless collaboration prompt');

interface TeamlessCollaborationPromptPopoverProps {
  boardId: string;
  onClose: () => void;
  onTeamCreated: () => void;
  target: PopoverProps['target'];
}

export const TeamlessCollaborationPromptPopover: React.FC<TeamlessCollaborationPromptPopoverProps> = ({
  boardId,
  onClose,
  onTeamCreated,
  target,
}) => {
  const [hasContinuedFromPrompt, setHasContinuedFromPrompt] = useState(false);

  // The Popover component accepts a function returning a React Node as its child
  const getPopoverContent = () =>
    hasContinuedFromPrompt ? (
      <TeamlessCollaborationCreateTeam
        boardId={boardId}
        onTeamCreated={onTeamCreated}
      />
    ) : (
      <div className={styles.createTeamPrompt}>
        <img
          src={require('resources/images/highFiveIllustration@2x.png')}
          alt=""
        />
        <h2 className={styles.createTeamTitle}>
          {format(['create team prompt', 'title'])}
        </h2>
        <p>{format(['create team prompt', 'description-2'])}</p>
        <Button
          className={styles.createTeamPromptContinueButton}
          onClick={() => setHasContinuedFromPrompt(true)}
          size={ButtonSizes.FULLWIDTH}
          buttonType={ButtonTypes.PRIMARY}
        >
          {format(['create team prompt', 'button'])}
        </Button>
      </div>
    );

  const onClosePopover = (closeMethod: string) => {
    onClose();
    if (closeMethod === closeMethods.CLOSE_BUTTON) {
      Auth.me().dismiss(`TeamlessCollaborationPrompt-${boardId}`);
      trackUe({
        category: Noun.BOARD_VIEW,
        verb: Verb.DISMISSES,
        directObj: Noun.TEAMLESS_COLLABORATION_PROMPT,
        method: 'by clicking the close button',
        context: {
          boardId,
        },
      });
    }
  };

  return (
    <Popover
      name={TeamlessCollaborationPromptPopoverId}
      offsetLeft={13}
      offsetTop={38}
      onClose={onClosePopover}
      target={target}
      title={format('popover title')}
    >
      {getPopoverContent}
    </Popover>
  );
};
